/* =========================================================
	SITE-WIDE SCRIPTS
	1.0 UIKit (v3)
	2.0 Home hero
========================================================= */

/* 1.0 UIKit (v3) ----------------------------------------------- */
import UIkit from 'uikit';
window.UIkit = UIkit;

/* 2.0 Home hero ----------------------------------------------- */
// Get media item (video or image)
let homeHeader = document.querySelector('.home-header');

// If it exists, do stuff
if (typeof(homeHeader) != 'undefined' && homeHeader != null) {
	let heroContent = document.querySelector('.header-content');

	// Update height of hero
	function updateHeroHeight() {
		// let heroMedia = document.querySelector('.media-item');
		let mediaItemHeight = document.querySelector('.media-item').offsetHeight;
		const newHeight = mediaItemHeight - 40; // Subtract 40px
		heroContent.style.height = `${newHeight}px`;
	}

	// Check for media query match initially
	if (window.matchMedia('(min-width: 768px)').matches) {
		updateHeroHeight();
	} else {
		heroContent.style.height = 'auto';
	}

	// Add event listener for resize event
	window.addEventListener('resize', () => {
		// Check for media query match
		if (window.matchMedia('(min-width: 768px)').matches) {
			 updateHeroHeight();
		} else {
			heroContent.style.height = 'auto';
		}
	});

	// Pause/play video
	const video = document.getElementById('hero-video');
	const playPauseBtn = document.getElementById('play-pause-btn');
	const playIcon = document.getElementById('play-icon');
	const pauseIcon = document.getElementById('pause-icon');

	playPauseBtn.addEventListener('click', function() {
		if (video.paused) {
			video.play();
			playIcon.style.display = 'none';
			pauseIcon.style.display = 'inline';
		} else {
			video.pause();
			playIcon.style.display = 'inline';
			pauseIcon.style.display = 'none';
		}
	});
}
